import React, { FC } from 'react';
import styles from './FindingOverlayCard.module.scss';
import { findingProps, getPropertyBackgroundColor } from '../Helpers';
import classNames from 'classnames';
import { RootState } from '../../../../rootReducer';
import { connect } from 'react-redux';
import { PropertyColumnData } from '../../../Shared/TableOptions/types';

const getStandard = (state: RootState) => state.annotation.annotationStandardDetails;

type Props = {
  finding: any | undefined;
  allProperties: PropertyColumnData[];
};

const formatValue = (key: any, value: any, propertyUnit: string) => {
  if ((key === 'DistanceToRootM' || key === 'DistanceToLeadingEdgeM') && value !== '') {
    return (
      parseFloat(value).toLocaleString('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 }) + ' ' + (propertyUnit ? propertyUnit : '')
    );
  }
  if ((key === 'LengthMm' || key === 'WidthMm' || key === 'HeightMm') && value !== '') {
    return (
      parseFloat(value).toLocaleString('en-US', { maximumFractionDigits: 0, minimumFractionDigits: 0 }) + ' ' + (propertyUnit ? propertyUnit : '')
    );
  }
  if (key === 'AreaMm2' && value !== '') {
    return (parseFloat(value) / 100).toLocaleString('en-US', { maximumFractionDigits: 0, minimumFractionDigits: 0 }) + ' cm²';
  }

  return value;
};

const FindingOverlayCardProperties: FC<Props> = (props: Props) => {
  const FindingOverlayCardProperty = (title: string, index: number, propertyName: string, value?: string | undefined) => {
    return (
      <tr key={index} className={styles.overlayProperty}>
        <td>{title}:</td>
        <td>
          <span
            className={classNames({ [styles.severity]: title === 'Severity' })}
            style={{ backgroundColor: getPropertyBackgroundColor(title, props.finding?.Severity), color: 'black', opacity: 0.7, textAlign: 'right' }}
          >
            {formatValue(propertyName, value, getPropertyUnit(propertyName, props.allProperties))}
          </span>
        </td>
      </tr>
    );
  };

  return <>{findingProps.map((x, index) => props.finding && FindingOverlayCardProperty(x.title, index, x.value, props.finding[x.value]))}</>;
};

const getPropertyUnit = (key: string, allProperties: PropertyColumnData[]) => {
  var property = allProperties.find(x => x.name === key);

  return property ? property.unit : '';
};

const mapStateToProps = (state: any) => {
  return {
    allProperties: state.annotation.annotationStandardDetails.findingTypes
      .map((x: any) =>
        x.findingTypeTemplate
          ? x.findingTypeTemplate.properties.map((y: any) => ({ id: y.id, name: y.name, fullName: y.fullName, unit: y.units }))
          : []
      )
      .flat()
  };
};
export default connect(mapStateToProps)(FindingOverlayCardProperties);
